import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { Input, Form } from "antd";
import { useNavigate } from "react-router";
import AuthStore from "../../../../stores/AuthStore";
import { getParamFromUrlSearch } from "../../../../utils/paramsUtil";
import styles from "./index.module.scss";
import VerifySlide from "../../../../components/VerifySlide";

interface LoginByAccountProps {
  setLoginType: (state: number) => void;
}
const LoginByAccount: React.FC<LoginByAccountProps> = (props) => {
  const [form] = Form.useForm();
  const { setLoginType } = props;
  const [captchaVerification, setCaptchaVerification] = useState<string>();
  const [isSlideShow, setIsSlideShow] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const navigate = useNavigate();

  const login = (captchaVerification?: string) => {
    // if (!captchaVerification) {
    //   setIsSlideShow(true);
    //   return;
    // }
    form
      .validateFields()
      .then((res) => {
        console.log(res);
        const values = form.getFieldsValue();
        const { phone, password } = values;
        const params = getParamFromUrlSearch<{ appkey?: string }>(
          document.location.search
        );
        AuthStore.ssoLogin(phone, password, params.appkey).then((res) => {
          if (res) {
            !params?.appkey && navigate("/client/userInfo/getUserInfo");
          } else {
            setCaptchaVerification(undefined);
          }
        });
      })
      .catch((err) => {});
  };

  return (
    <div className={styles.auth_form}>
      <div className={styles.title}>
        <div style={{ cursor: "pointer" }} onClick={() => setLoginType(2)}>
          短信登录
        </div>
        <div style={{ cursor: "pointer", color: "#FFC75D" }}>密码登录</div>
        <div style={{ cursor: "pointer" }} onClick={() => setLoginType(3)}>
          钉钉扫码
        </div>
      </div>
      <div className={styles.line}>
        <div className={styles.lineChild}></div>
      </div>
      <Form form={form}>
        <Form.Item
          name="phone"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "请输入手机号码或账号",
            },
          ]}
        >
          <Input
            placeholder="请输入手机号码或账号"
            className={styles.input}
            style={{ marginTop: "48px" }}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              whitespace: true,
              message: "请输入密码",
            },
          ]}
        >
          <Input.Password
            placeholder="请输入密码"
            iconRender={(visible) =>
              visible ? (
                <img
                  src={require("../../../../assets/iconImg/eyeTrue.png")}
                  style={{ width: "18.5px", marginRight: "20px" }}
                />
              ) : (
                <img
                  src={require("../../../../assets/iconImg/eyeFalse.png")}
                  style={{ width: "18.5px", marginRight: "20px" }}
                />
              )
            }
            onKeyDown={(e) =>
              e.key === "Enter" && (isCheck ? login() : setIsSlideShow(true))
              
            }
          />
        </Form.Item>
      </Form>
      {ReactDOM.createPortal(
        <VerifySlide
          isSlideShow={isSlideShow}
          onCancel={() => setIsSlideShow(false)}
          onSuccess={(code: string = "") => {
            setIsCheck(true);
            AuthStore.setSafeCode(code);
            AuthStore.setIsIntimePeriod(true);
            login(captchaVerification);
          }}
        />,
        document.body
      )}
      {isCheck ? (
        <button
          onClick={() => login(captchaVerification)}
          className={styles.login}
        >
          登录
        </button>
      ) : (
        <button className={styles.login} onClick={() => setIsSlideShow(true)}>
          安全校验
        </button>
      )}

      <div className={styles.forget}>
        <span>忘记密码</span>
      </div>
      {/* <div className={styles.registry} onClick={() => setIsLogin(false)}>
        <span>立即注册</span>
      </div> */}
      {/* <footer>
        <span onClick={() => props.setIsLoginByAccount(false)}>验证码登录</span>
        <span onClick={() => setIsLogin(false)}>前往注册</span>
      </footer> */}
    </div>
  );
};

export default LoginByAccount;
